import type { TriggerDesignsState } from "../../../../schemas/index.ts";

export const getTriggerIds = ({ ids, effects, conditions }: TriggerDesignsState): number[] => {
  const triggerIds = Object.values(ids.triggerIdsByNodeId).flat();
  const handlerIds = Object.values(ids.handlerIdsByTriggerId).flat();
  const responseIds = Object.values(ids.responseIdsByHandlerId).flat();
  const effectIds = Object.values(effects.idsByResponseId).flat();
  const conditionIds = Object.keys(conditions.byId).map(Number);
  return [...triggerIds, ...handlerIds, ...responseIds, ...effectIds, ...conditionIds];
};
